export function isSubset(superObj, subObj, ignoreNotInSuper=false) {
  return Object.keys(subObj).every((key) => {
    if (typeof subObj[key] == 'object') {
      if (superObj[key] === undefined || superObj[key] === null) {
        return ignoreNotInSuper;
      }
      return isSubset(superObj[key], subObj[key]);
    }
    if (superObj[key] === undefined || superObj[key] === null) {
      return ignoreNotInSuper;
    }
    return subObj[key] === superObj[key];
  });
}
